import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MAIN_DOMAIN = "https://rakibhossentopu.online";

const CanonicalTag = () => {
  const location = useLocation();

  useEffect(() => {
    // Build canonical URL based on current route
    const canonicalPath = location.pathname === "/" ? "/" : location.pathname;
    const canonicalUrl = `${MAIN_DOMAIN}${canonicalPath}`;

    // Find existing canonical link or create new one
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    
    canonicalLink.href = canonicalUrl;

    // Also update og:url meta tag
    let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
    
    if (!ogUrl) {
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      document.head.appendChild(ogUrl);
    }
    
    ogUrl.content = canonicalUrl;

  }, [location.pathname]);

  return null;
};

export default CanonicalTag;
